import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createTransactionTypeService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.transactionTypes, payload)).data;
};

export const getTransactionTypeService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.transactionTypes}`, signal)).data; 
}

export const updateTransactionTypeService = async (payload) => {
  let filteredPayload = {
    "transactionTypeId" : payload.transactionTypeId,
    "transactionType": payload.transactionType,
  }
  return (await axiosInstance.put(`${APIROUTE.transactionTypes}/${payload.transactionTypeId}`, filteredPayload)).data;
};